import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUitloggen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FED27A"
      d="M24 9.5H9v21h15z"
    />
    <path
      fill="#F18700"
      d="M26.59 16.55h-6.94v6.94h6.94z"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="M25 26.16V13.88l9 6.14z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A941"
      fillRule="evenodd"
      d="M21 33.5 9 30.65V9.35L21 6.5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUitloggen);

export default ForwardRef;
